// extracted by mini-css-extract-plugin
export default {"container":"TemplateZero_container__2Cizf","multiNode":"TemplateZero_multiNode__yHwml"};